import React, { Component } from 'react';
import styled from 'styled-components';
import { convert } from 'ethereumjs-units';

import Perks from './components/Perks';
import './App.css';
import AuctionEndCountDown from './components/AuctionEndCountdown';

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 550px) {
    display: block;
  }
`;

const InfoItem = styled.div`
  width: 30%;
  text-align: left;
  margin-bottom: 2em;

  @media (max-width: 550px) {
    width: auto;
  }
`;

const InfoTitle = styled.div`
  font-size: 0.7em;
`;

const CurrentHighestOffer = styled.div`
  font-size: 2em;
`;

const BidderAddress = styled.div`
  word-break: break-all;
`;

const Loading = styled.div`
  text-align: center;
  padding: 50px;
`;

const KITTY_ID = '286600';

class App extends Component {
  state = { offer: undefined, isLoading: true };
  componentDidMount = async () => {
    const raw = await fetch(`https://api.cryptokitties.co/kitties/${KITTY_ID}`);
    const json = await raw.json();
    this.setState({ offer: json.offer, isLoading: false });
  };

  render() {
    const { offer, isLoading } = this.state;

    if (isLoading) {
      return <Loading>Loading...</Loading>;
    }

    const hasOffer = false;

    return (
      <div className="App">
        <Loading>
          The auction is over. Stay tuned by subscribing to the{' '}
          <a href="https://www.youtube.com/channel/UCDlkevNWJb9dSq4eZDnI1kg">
            CryptoMngwa YouTube channel
          </a>
        </Loading>
      </div>
    );
  }
}

export default App;
